export const appConfig = {
  apiUrl: process.env.REACT_APP_BACKEND_BASE_URL,
  fingerprintApiKey: process.env.REACT_APP_FINGERPRINT_PUBLIC_KEY,
};
